import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { Modal } from 'bootstrap';
import { Login } from 'src/app/Entities/Login';
import { AuthService } from 'src/app/Services';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.css']
})
export class ModalLoginComponent {
  @Output() onAcceder = new EventEmitter();
  @ViewChild('modalRef') modalRef?: ElementRef;

  myModal?: Modal;
  recuperar_acceso: boolean = false;
  correo: string = '';

  constructor(public authService: AuthService,) { }
  ngAfterViewInit(): void { }

  show() {
    if (!this.myModal) {
      this.iniciarModal();
    }
    this.myModal!.show();
  }
  hide() {
    this.myModal?.hide();
  }

  iniciarModal() {
    this.myModal = new Modal(this.modalRef!.nativeElement, {
      keyboard: false,
    });
  }

  onAccederClick(usr: string, pass: string) {
    const body: Login = {
      user_name: usr,
      password: pass,
    };
    this.onAcceder.emit(body);
  }

  onRecuperarAcceso() {
    this.recuperar_acceso = true;
  }

  onCancelarRecuperacion() {
    this.recuperar_acceso = false;

  }

  onConfirmarRecuperarAcceso(correo: string) {
    this.authService.restore(correo).subscribe(({ data }) => {
        console.log(data);
        Swal.fire(
          'Solicitud enviada correctamente',
          data,
          'success'
        );
      });
  }
}
